import React from "react";
import { userprofile, Verifyemailmobile } from "../../Model/Users"; //Include Home
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { UserchangeSendpin } from "../../Model/Users";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import * as CountryCode from "../../Config/CountryCode.js";
import { Link } from "react-router-dom";
import Enterpincode from "./Enterpincode";
import BarLoader from "react-spinners/BarLoader";
var SVGIcon = "";
var ImageData = "";
SVGIcons().then((resultData) => (SVGIcon = resultData));
ImgIcons().then((result) => (ImageData = result));
class Verifymobile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        fld_mobile: "",
        country_code: "+91",
        fld_email: "",
        fld_password: "",
      },
      errors: { isValidEmailerror: false, isValidMobileerror: false },
      msg: { alreadyRegiter: false, validpasswordMsg: false },
      showEnterpin: false,
      isValidEmail: false,
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      ButtonDisable: true,
      SuccessMobileChange: false,
      RequestType: "verify"
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      let data = {
        seesionID:localStorage.getItem("session_id"),
        userID:localStorage.getItem("userID")
      }
      userprofile(data).then((userprofile) => {
        if (userprofile.data.success == false) {
          this.props.navigate("/manage-profile");
        } else {
          var postdata = {
            verifyMobile: true,
          }
          Verifyemailmobile(postdata).then((response) => {
            var Response = JSON.parse(response.data);
            if (Response.success == true) {
              this.setState({
                VirsionCheckData: vcheckres,
                VirsionCheckDataloaded: true,
                DataisLoaded: true,
                ProfileData: userprofile,
                showEnterpin: true
              });
            } else {
              //Something went wrong
            }
          })
        }
      });
    });
  }

  async checkuser() {
    var EmailorMobile = { fields: this.state.fields, action: "update" };

    await UserchangeSendpin(EmailorMobile).then((data) => {
      var CheckuserData = JSON.parse(data.data);

      if (CheckuserData.success == false) {
        var errorState = this.state.errors;
        if (EmailorMobile.fields.fld_email) {
          errorState["isValidEmailerror"] = true;
        } else if (EmailorMobile.fields.fld_mobile) {
          errorState["isValidMobileerror"] = true;
        }
        var AlreadyExistMsg = this.state.msg;
        AlreadyExistMsg["alreadyRegiter"] = CheckuserData.message;
        this.setState({ errorState, AlreadyExistMsg });
      } else {
        //success pin send

        var AlreadyExistMsg = this.state.msg;
        AlreadyExistMsg["passwordsent"] = CheckuserData.message;
        this.setState({ errorState, AlreadyExistMsg });
        this.setState({
          showEnterpin: true,
        });
      }
    });
  }
  handleChange(e) {
    const fields = this.state.fields;

    if (e.target.name == "fld_mobile" && /\s/.test(e.target.value) == false) {
      var errorState = this.state.errors;
      errorState["isValidMobileerror"] = false;
      this.setState({ errorState });

      if (
        e.target.value.length >= 8 &&
        e.target.value.length <= 15 &&
        !isNaN(e.target.value)
      ) {
        this.setState({
          isValidMobile: true,
          ButtonDisable: false,
        });
      } else {
        this.setState({
          isValidMobile: false,
          ButtonDisable: true,
        });
      }
    }

    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  }
  CustomeBackButton() {
    this.setState({
      showEnterpin: false,
    });
  }
  /*-------Logout-------*/
  backbtn() {
    this.props.navigate("/manage-profile");
  }
  popupshow() {
    this.setState({ SuccessMobileChange: true, showEnterpin: false });
  }


  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else if (this.state.showEnterpin) {
      return <Enterpincode data={this} title="Verify" />;
    } else {
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <>
              <header>
                <div className="mainNav pmenu dD-none">
                  <div className="docubayBack white">
                    <Link to="/manage-profile">
                      <img src="img/svg/back.svg" alt="DocuBay" />
                    </Link>{" "}
                    Verify Mobile Number
                  </div>
                </div>
              </header>
              <main>
                {/* <section className="mb-0">
                  <div className="homeBanner">
                    <div className="innerBanner mb-0">
                      <div className="title-mail">
                        <h1>
                          Change <span className="red">Mobile Number</span>
                        </h1>
                        <div className="reset">
                          Enter the new mobile number that will be linked to
                          your DocuBay account.We will send a verification code
                          to this mobile number, please enter that code below
                          for verification.
                        </div>
                      </div>
                    </div>
                  </div>
                </section> */}
                <section style={{ paddingBottom: 45 }}>
                  <div className="temp31">
                    <div className="temp31Inner">
                      <div
                        className={
                          this.state.errors.isValidMobileerror
                            ? " formField error-border data"
                            : true
                              ? "formField data "
                              : "formField data "
                        }
                        ref={this.emailInput}
                      >
                        <select
                          name="country_code"
                          onChange={this.handleChange}
                          className="selectTel"
                        >
                          {CountryCode.Countrycode.map((CoutryData) => {
                            return (
                              <option
                                key={CoutryData.name}
                                value={CoutryData.dial_code}
                              >
                                {CoutryData.dial_code}
                              </option>
                            );
                          })}
                        </select>
                        <input
                          name="fld_mobile"
                          type="tel"
                          className="inputTel"
                          placeholder="Enter new mobile number"
                          value={this.state.fields.fld_mobile}
                          onChange={this.handleChange}
                          minLength="6"
                          maxLength="15"
                          autoComplete="off"
                          autoComplete="new-password"
                          required
                        />
                      </div>
                      {this.state.errors.isValidMobileerror ? (
                        <div className="error error-verifyotp">
                          <img src={SVGIcon["error.svg"]} alt="DocuBay" />
                          <p>{this.state.msg.alreadyRegiter} </p>
                        </div>
                      ) : null}
                      <div
                        className="passChangepopup"
                        style={{
                          display: this.state.SuccessMobileChange
                            ? "flex"
                            : "none",
                        }}
                        id="passChange"
                      >
                        <div className="temp31-modal-body">
                          <button
                            className="temp31-modal-close temp31-modal-toggle"
                            onClick={() => {
                              this.backbtn();
                            }}
                          >
                            <img
                              src={SVGIcon["promocode-close.svg"]}
                              alt="DocuBay"
                            />
                          </button>
                          <img
                            src={SVGIcon["phone.svg"]}
                            height="60px"
                            alt="DocuBay"
                            className="imgPass"
                          />
                          <div className="temp31-awesome">
                            <h5>Mobile number Verified!</h5>
                            <h6>Your mobile number has been Verified successfully</h6>
                          </div>
                          <Link
                            to="/"
                            type="submit"
                            id="sendEnquiryBtn"
                            className="btn-white"
                          >
                            Back to Home
                          </Link>
                        </div>
                      </div>

                      <div className="formField mt-24 mb-24">
                        <a href="#" className="temp31-modal-toggle">
                          {" "}
                          <button
                            type="submit"
                            id="sendEnquiryBtn"
                            disabled={this.state.ButtonDisable}
                            className={
                              this.state.ButtonDisable ? "btn-black" : "btn-red"
                            }
                            onClick={() => {
                              this.checkuser();
                            }}
                          >
                            Verify
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                </section>
              </main>
            </>
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Verifymobile);
